<form [formGroup]="filterForms" (ngSubmit)="checkAndCallMethods()">
    @if (localTableFilters) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>Filter</mat-label>
        <mat-select formControlName="tableFilter" (selectionChange)="changeValue($event)" [compareWith]="compareFilters">
            @for (filter of localTableFilters; track $index) {
            <mat-option [value]="filter">
                {{ filter.displayName }}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    }
    @if (filterForms.get('tableFilter')?.value) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>{{ filterForms.value.tableFilter.displayName || "" }}</mat-label>

        @if (isArray() && !dateFilterSelected) {
        <mat-select formControlName="value">
            @for (val of filterForms.value.tableFilter.values; track $index) {
            <mat-option [value]="val">
                {{val}}
            </mat-option>
            }
        </mat-select>
        } @else if (isArray() && dateFilterSelected) {
        <mat-select formControlName="value" (selectionChange)="applyTheme()">
            <!-- <mat-option value="Date Received">Date Received</mat-option>
            <mat-option value="Scheduled Start Date">Scheduled Start Date</mat-option> -->
            @for (val of filterForms.value.tableFilter.values; track $index) {
            <mat-option [value]="val">
                {{val}}
            </mat-option>
            }
        </mat-select>
        } @else {
        @if (!dateFilterSelected) {
        <input matInput placeholder="{{ filterForms.value.tableFilter.displayName || '' }}" formControlName="value" />
        }
        }
    </mat-form-field>
    }
    @if (dateFilterSelected && scheduledStartDate && !dateReceived) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>Choose date range</mat-label>
        <input matInput type="text" bsDaterangepicker [minDate]="scheduledminDate" [maxDate]="scheduledmaxDate"
            [bsConfig]="bsConfig" [(bsValue)]="bsRangeValue" (bsValueChange)="updateMyDate($event)"
            (click)="bsRangeValue = undefined">
    </mat-form-field>
    }
    @if (dateFilterSelected && !scheduledStartDate && dateReceived) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>Choose date range</mat-label>
        <input matInput type="text" bsDaterangepicker [minDate]="minDate" [maxDate]="maxDate" [bsConfig]="bsConfig"
            [(bsValue)]="bsRangeValue" (bsValueChange)="updateMyDate($event)" (click)="bsRangeValue = undefined">
    </mat-form-field>
    }
    <div class="buttons">
        <button mat-flat-button color="primary" class="button" type="submit" [disabled]="isFilterSet()"
            (click)="isAddFilterCliecked()">
            Add
        </button>
        <button mat-flat-button color="primary" class="button" type="submit" [disabled]="!isWONumberFilterApplied()"
            (click)="isSearchClicked()">
            Search
        </button>
        <button mat-stroked-button class="button" [disabled]="!isAnyFilterSet()" (click)="reset()">
            Reset
        </button>
    </div>
</form>

@if (filterAdded) {
<div class="chips">
    <mat-chip-set aria-label="Filter selection">
        @for (filters of filterArray; track $index) {
        <mat-chip (removed)="remove(filters.value)">
            {{ filters.dispalyName }} - {{ filters.value }}
            @if (removable) {
            <button matChipRemove [attr.aria-label]="'remove ' + filters.value">
                <mat-icon>cancel</mat-icon>
            </button>
            }
        </mat-chip>
        }
    </mat-chip-set>
</div>
}

@if (isLoadingResults) {
<div class="loading-shade">
    @if (isLoadingResults) {
    <mat-spinner></mat-spinner>
    }
</div>
}